import { render, staticRenderFns } from "./notifications2.vue?vue&type=template&id=2986a413"
import script from "./notifications2.vue?vue&type=script&lang=js"
export * from "./notifications2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports